import { Button } from '@framework/ui/atoms/Button';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { GroupId } from 'balus-common';
import { CardSubscriptionCheckoutPanel } from './CardSubscriptionCheckoutPanel';

type Props = {
  groupId: GroupId;
  isTrial: boolean;
  onClose(): void;
  onSelectInvoice(): void;
};

export const StandardPaymentMethodModal: React.FC<Props> = ({ groupId, isTrial, onClose, onSelectInvoice }: Props) => {
  const { t } = useTranslation();
  const [showCardCheckout, setShowCardCheckout] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (showCardCheckout) contentRef.current?.focus();
  }, [showCardCheckout]);
  const title = t(showCardCheckout ? 'group.cardSubscriptionCheckout.title' : 'group.standardPaymentMethod.title');

  return (
    <GeneralModal
      isOpen
      onClose={onClose}
      title={title}
      contentLabel={title}
      submitButton={<></>}
      cancelButton={
        <Button color="flat" onClick={onClose}>
          {t('common.action.close')}
        </Button>
      }
      containerClassName="max-h-[75vh] overflow-y-auto px-3 pb-3"
    >
      <div ref={contentRef} tabIndex={-1}>
        {showCardCheckout ? (
          <CardSubscriptionCheckoutPanel groupId={groupId} isTrial={isTrial} />
        ) : (
          <div className="flex flex-col gap-3 py-4">
            <Button color="flat" onClick={onSelectInvoice}>
              {t('group.standardPaymentMethod.invoice.label')}
            </Button>
            <Button color="brand" onClick={() => setShowCardCheckout(true)}>
              {t('group.standardPaymentMethod.card.label')}
            </Button>
          </div>
        )}
      </div>
    </GeneralModal>
  );
};
